export default __webpack_public_path__ + "static/media/space3.40439bdb.png";